import { render } from "./highlight-overlay.vue?vue&type=template&id=ad106bc6&scoped=true&ts=true"
import script from "./highlight-overlay.vue?vue&type=script&lang=ts"
export * from "./highlight-overlay.vue?vue&type=script&lang=ts"

import "./highlight-overlay.vue?vue&type=style&index=0&id=ad106bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad106bc6"]])

export default __exports__